/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 10:37:45
 */

import CompareException from "../compareException";
import {Toast} from "src/util/toast";
import {default as CellOperate} from "src/components/agGridComponent/cellOperate";
import {IconBtnItem} from "src/components/iconBtnGroup/iconBtnGroup";
import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
import CompareExceptionApi,{CompareExceptionDOI} from "../api/compareExceptionApi";
import ListPageService from 'src/types/ListPage';
import override from "src/dectorators/override";
import {QueryFormVOI} from "src/components/queryForm/queryForm";
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import Input from 'src/types/iview/Input';
import alertOperateCompareExceptionModal from '../operateCompareExceptionModal';
import EnumOperates from 'src/enums/enumOperates';
import EnumExceptionStatus from 'src/enums/enumExceptionStatus';
import alertViewExceptionCompareModal from '../viewExceptionCompareModal';

export default class CompareExceptionService extends ListPageService {
	ctx: CompareException;

	constructor (ctx: CompareException) {
	    super()
		this.ctx = ctx
	}

    @override
	createColumns (): ColDefCustom [] {
		let t = this
		return [
			{
                headerName: '通知单号',
                field: 'inform_number',
                minWidth: 120,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: CompareExceptionDOI.RowDataI = params.data;
                        return (
                            <div
                                class="wqms-cursor wqms-link"
                                on-click={() => {
                                    alertViewExceptionCompareModal( data.id);
                                }}
                            >
                                {data.inform_number}
                            </div>
                        );
                    },
                },
            },
            {
                headerName: '发起人',
                field: 'initiator',
                minWidth: 100,
            },
            {
                headerName: '发起时间',
                field: 'sponsor_datetime',
                minWidth: 170,
            },
            {
                headerName: '异常站点',
                field: 'abnormity_site',
                minWidth: 140,
                cellRenderer(params) {
                    let data: CompareExceptionDOI.RowDataI = params.data;
                    data.abnormity_site = data.abnormity_site||{data:[]}
                    return data.abnormity_site.data.map(i=>i.operational_site).join(',')
                },
            },
            {
                headerName: '处理单位',
                field: 'dispose_company',
                minWidth: 100,
            },
            {
                headerName: '状态',
                field: 'status',
                minWidth: 100,
                cellRenderer(params) {
                    let data: CompareExceptionDOI.RowDataI = params.data;
                    return EnumExceptionStatus.findId(data.status).getName();
                },
            },
            {
                headerName: '审核人',
                field: 'auditor',
                minWidth: 100,
            },
			{
				headerName: '操作',
				field: 'operate',
				minWidth: 120,
				maxWidth: 120,
				// pinned: 'right',
				cellRendererFramework: CellOperate,
				cellRendererFrameworkOpt: [
					{
                        text: '修改',
                        disabled(params) {
                            let data: CompareExceptionDOI.RowDataI = params.data;
                            return data.status!==EnumExceptionStatus.已下达.getId();
                        },
                        async click(params) {
                            let data: CompareExceptionDOI.RowDataI = params.data;
                            let res = await alertOperateCompareExceptionModal(EnumOperates.Update.getName(),data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        disabled(params) {
                            let data: CompareExceptionDOI.RowDataI = params.data;
                            return data.status!==EnumExceptionStatus.已下达.getId();
                        },
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: CompareExceptionDOI.RowDataI = params.data;
                            await t.delete([data.id]);
                        },
                    },
				]
			},
		]
	}

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            
            {
                component: CommonSelect,
                label: '状态：',
                field: 'status',
                props: { value: null, dataSource: EnumExceptionStatus.getList() },
            },
            {
                component: DatePicker,
                label: '发起时间',
                field: 'time',
                width: 300,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
            },
            {
                component: Input,
                labelWidth: 20,
                label: '',
                field: 'keyword',
                props: { value: '', placeholder: '请输入' },
            },
        ];
    }

	async delete(ids: number[]) {
		let {code} = await CompareExceptionApi.delete({ids})
		if (code=== 0) {
			Toast.success('删除成功')
			this.searchTable()
		}
    }
    
    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertOperateCompareExceptionModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            },
            {
                text: '删除',
                type: 'info',
                async onClick() {
                    let gridOptions: any = t.ctx.gridOptions;
                    let selectRows: CompareExceptionDOI.RowDataI[] = gridOptions.api.getSelectedRows();
                    if (selectRows.length === 0) {
                        return Toast.warning('请选择要操作的数据');
                    }
                    if(selectRows.some(i=> i.status!==EnumExceptionStatus.已下达.getId())) {
                        return Toast.error('已处理的数据不能删除！')
                    }
                    let res = await Toast.confirm();
                    if (!res) {
                        return;
                    }
                    let ids: number[] = selectRows.map(item => item.id);
                    await t.delete(ids);
                },
            },
        ];
    }

	@override
	initSearchParams (): void {
		this.ctx.searchParams = this.ctx.queryForm.getQueryObj<CompareExceptionDOI.QueryRowDataParamsI>()
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		ag.showLoading()
		let {code, data} = await CompareExceptionApi.searchList({
			...ctx.searchParams,
			page_size: ctx.pageSize,
			page_index: ctx.currentPage
		})
		ag.hideLoading()

		if (code === 0) {
			ctx.rowData = data.data_info || []
			ctx.total = data.page_count
		}
	}

}